import { Link } from 'react-router-dom'
import { serviceItems, pricingPlans } from '../data/services.js'
import PersonBanner from '../components/PersonBanner.jsx'
import Footer from '../components/Footer.jsx'

export default function Services() {
    return (
        <div className="mil-content">
            <div className="mil-scroll-wrapper transition-fade" id="swupMain">
                <div className="mil-container">
                    <section className="mil-banner-sm mil-center">
                        <div className="mil-banner-top mil-up"></div>
                        <div className="mil-banner-title">
                            <h1 className="mil-h1-sm mil-up mil-mb-60">This is what i do best</h1>
                            <ul className="mil-breadcrumbs mil-up">
                                <li>
                                    <Link to="/">Homepage</Link>
                                </li>
                                <li>
                                    <Link to="/services">Services</Link>
                                </li>
                            </ul>
                        </div>
                    </section>

                    <section className="mil-p-0-30">
                        <div className="row justify-content-between align-items-center">
                            {serviceItems.map((service) => (
                                <div className="col-lg-4" key={service.title}>
                                    <div className="mil-icon-box mil-center mil-mb-60">
                                        <div className="mil-service-icon mil-up">
                                            {/* <img src={service.icon} alt="icon" className="mil-mb-30" /> */}
                                            <i className={`${service.icon} mil-mb-30`}></i>
                                        </div>
                                        <h5 className="mil-up mil-mb-30">{service.title}</h5>
                                        <p className="mil-up mil-mb-30">{service.description}</p>
                                        <div className="mil-up">
                                            <Link to="/services" className="mil-link mil-icon-link">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="feather feather-arrow-right"
                                                >
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                    <polyline points="12 5 19 12 12 19"></polyline>
                                                </svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <div className="mil-section-title mil-up">
                        <div className="mil-divider"></div>
                        <h3>Price</h3>
                    </div>

                    <section className="mil-p-90-60">
                        <div className="row">
                            {pricingPlans.map((plan) => (
                                <div className="col-lg-6" key={plan.title}>
                                    <div className="mil-price-card mil-up mil-mb-30">
                                        <h4 className="mil-upper mil-accent mil-up mil-mb-30">{plan.title}</h4>

                                        <div className="mil-price-number mil-up mil-mb-30">
                                            {plan.price} <span>{plan.period}</span>
                                        </div>

                                        <p>{plan.shortDesc}</p>

                                        <div className="mil-divider mil-up mil-mb-30"></div>

                                        <ul className="mil-mb-60">
                                            {plan.features.map((feature) => (
                                                <li key={feature.text} className={`mil-up${feature.included ? '' : ' mil-empty'}`}>
                                                    {feature.text}
                                                </li>
                                            ))}
                                        </ul>

                                        <Link to={plan.ctaLink} className="mil-link mil-up">
                                            <span>{plan.ctaLabel}</span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="feather feather-arrow-right"
                                            >
                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                                <polyline points="12 5 19 12 12 19"></polyline>
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <div className="mil-divider mil-up mil-mb-90"></div>

                    <section id="about" className="mil-p-0-90">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="mil-center">
                                    <h2 className="mil-up mil-mb-30">Ready to bring your ideas to life? I'm here to help</h2>
                                    <div className="mil-up">
                                        <Link to="/contact" className="mil-btn mil-sm-btn">
                                            Contact me
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Footer />
                </div>
            </div>

            <PersonBanner />
        </div>
    )
}
